import { Container } from "@mui/material";
import { FocusScope } from "@react-aria/focus";
import { Sheet, SheetBackdrop, SheetContainer, SheetContent, SheetHeader } from "./sheet/index.js";
import { useDialog } from "@react-aria/dialog";
import { useOverlay, useModal } from "@react-aria/overlays";
import * as React from "react";
export const ModalSheet = ({ allowClose = true, children, detent = "content-height", label, onClose, open, snapPoints, ...rest }) => (React.createElement(Sheet, { ...rest, detent: detent, isOpen: open, onClose: onClose, snapPoints: snapPoints },
    React.createElement(FocusScope, { contain: true, autoFocus: true, restoreFocus: true },
        React.createElement(A11ySheetContent, { allowClose: allowClose, label: label, onClose: onClose, open: open },
            React.createElement(Container, { maxWidth: "xl", sx: { pb: 6, maxWidth: "100%" } }, children)))));
const A11ySheetContent = ({ allowClose, children, label, onClose, open }) => {
    const a11yProps = useA11ySheet({ label, onClose });
    return (React.createElement(React.Fragment, null,
        React.createElement(SheetContainer, { ...a11yProps, "data-testid": "modal-sheet-container" },
            React.createElement(SheetHeader, { disableDrag: !allowClose }),
            React.createElement(SheetContent, { disableDrag: true }, children)),
        React.createElement(SheetBackdrop, null)));
};
const useA11ySheet = ({ label, onClose }) => {
    const ref = React.useRef(null);
    const dialog = useDialog({ "aria-label": label }, ref);
    const overlay = useOverlay({ onClose, isOpen: true, isDismissable: true }, ref);
    useModal();
    return {
        ref,
        ...overlay.overlayProps,
        ...dialog.dialogProps,
    }; // HACK: fix type conflicts with Framer Motion
};
//# sourceMappingURL=modal-sheet.js.map